import { styled } from '@slal/ui';
import { P } from '@slal/ui/typography';
import { LoadingSpinner } from '~/components';

export const StyledSpinner = styled(LoadingSpinner)`
    display: block;
    width: 50px;
    color: #147cb3;
    margin: 10px auto 15px auto;
`;

export const StyledSpinnerLabel = styled(P)`
    font-size: ${({ theme }) => theme.fontSizes[3]};
    color: ${({ theme }) => theme.colors.neutral__light__70};
    text-align: center;
`;

export const ChartCaption = styled.figcaption`
    font-size: ${({ theme }) => theme.fontSizes[3]};
    color: #051a3f;
    padding: 5px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-left: 35px;
`;

export const ChartIndicator = styled.span`
    width: 20px;
    height: 20px;
    background: #0a2f73;
    border-radius: 4px;
    display: inline-block;
`;
